import { v4 as uuidv4 } from 'uuid';

const typesOfFlowsMap = {
  Viber: 'ViberMessage',
  email: 'Email',
  'SMS / Text Message': 'TextMessage',
  'Push Notification': 'PushNotification',
  'Facebook Ad': 'FacebookAd',
  'Whatsapp Message': 'WhatsappMessage',
  'Google Ad': 'GoogleAd',
};

const daysOfweek = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

export const getTypeOfFlow = (type) => {
  return typesOfFlowsMap[type] || type;
};

const createFlowNodeConfig = (flowType) => {
  const config = [
    { field: 'id', name: `${getTypeOfFlow(flowType)}`, type: 'select' },
    { name: 'Send on', type: 'sectionStart', overview: { name: '' } },
    ...daysOfweek.map((dayOfWeek) => ({
      field: `runOn${dayOfWeek}`,
      name: `${dayOfWeek}`,
      type: 'checkbox',
      overview: { name: dayOfWeek.substring(0, 3), inline: true },
    })),
    { name: '', type: 'sectionStart' },
    { field: 'observeQuietHours', name: 'Observe quiet hours', type: 'checkbox' },
  ];

  if (flowType === 'Google Ad') {
    config.splice(1, 0, {
      field: 'membershipDurationDays',
      name: 'Membership Duration',
      type: 'number',
      default: 30,
      min: 1,
      max: 540,
      detailsSuffix: 'days',
    });
  }

  return config;
};

const createFlowNodeValues = (flowType, flowElementId) => {
  return daysOfweek.reduce(
    (days, day) => {
      days[`runOn${day}`] = true;
      return days;
    },
    {
      observeQuietHours: true,
      id: flowElementId,
      ...(flowType === 'Google Ad' && { membershipDurationDays: 30 }),
    }
  );
};

export const createFlowNode = (flowType, flowElementId, flowElementName, position) => {
  const config = createFlowNodeConfig(flowType);
  const values = createFlowNodeValues(flowType, flowElementId);

  return {
    id: getTypeOfFlow(flowType) + flowElementId,
    type: 'default',
    position,
    data: {
      label: `Send ${flowType}`,
      custom: {
        key: `send${getTypeOfFlow(flowType)}`,
        config,
        values,
        labels: { id: flowElementName },
      },
    },
  };
};

export const updateFlowNodeElementId = (flow, flowType, flowElementId) => {
  const updatedFlow = JSON.parse(JSON.stringify(flow));
  const node = updatedFlow.nodes.find((obj) => obj.id === flowType);

  if (node && node.data && node.data.custom && node.data.custom.values) {
    node.data.custom.values.id = flowElementId;
  }

  return updatedFlow;
};

export const generateEdgeId = (source, target) => {
  return `edge-${source}-to-${target}-${uuidv4()}`;
};

export const createCampaignFlow = (flowType, flowElementId) => {
  const flow = {
    offset: {
      x: 0,
      y: 0,
    },
    nodes: [
      {
        id: 'start',
        type: 'start',
        position: {
          x: 300,
          y: 100,
        },
        data: {
          label: 'Start',
          custom: {
            key: 'start',
            config: [],
            values: {},
          },
        },
      },
    ],
    edges: [],
  };

  const nodeType = flowType || 'email';
  const nodeId = flowType || 'email';

  let nodeValues = { observeQuietHours: true };
  if (flowElementId) {
    nodeValues = createFlowNodeValues(nodeType, parseInt(flowElementId));
  }

  let nodeConfig = [{ field: 'id', name: 'Email', type: 'select' }];
  if (flowType) {
    nodeConfig = createFlowNodeConfig(flowType);
  }

  flow.nodes.push({
    id: nodeId,
    type: 'default',
    position: {
      x: 276,
      y: 254,
    },
    data: {
      label: flowType ? `Send ${getTypeOfFlow(flowType)}` : 'Send Email',
      custom: {
        key: flowType ? `send${getTypeOfFlow(flowType)}` : 'sendEmail',
        config: nodeConfig,
        values: nodeValues,
        labels: {},
      },
    },
  });

  flow.edges.push({
    id: generateEdgeId('start', nodeId),
    source: 'start',
    target: nodeId,
  });

  return flow;
};
